import { Paper, PaperProps } from '@mui/material';
import { styled } from '@mui/system';

interface StyledPaperProps extends PaperProps {
  color: 'primary' | 'secondary',
  transparent?: boolean
}

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'transparent',
})<PaperProps>(({ theme, color, transparent = false }) => {
  const backgroundSetting = transparent ? {} : {
    backgroundColor: 'rgb(255,255,255,0.12)',
    boxShadow: '10px 0px 20px 0px #0000001F inset',
  }
  const background = {
    border: `1px solid ${theme.palette.background.border}`,
    ...backgroundSetting
  }
  return ({
    ...background,
  })
}
)

const AppliedStyle = (props: StyledPaperProps) => {
  return <StyledPaper {...props}>
    {props.children}
  </StyledPaper>
}

export default AppliedStyle